export const FLOOR_MAP_IMAGE_WIDTH_MIN = 200;
export const FLOOR_MAP_IMAGE_WIDTH_MAX = 1600;
export const FLOOR_MAP_IMAGE_HEIGHT_MIN = 480;
export const FLOOR_MAP_IMAGE_HEIGHT_MAX = 960;
export const FLOOR_MAP_IMAGE_HEIGHT_VIEWPORT_RATIO = 0.45;
export const FLOOR_MAP_ZOOM_MIN = 0.5;
export const FLOOR_MAP_ZOOM_MAX = 3;
export const FLOOR_MAP_ZOOM_STEP = 0.1;

export const getFloorMapImageHeightMax = (viewportHeight: number): number =>
  Math.round(
    Math.min(
      FLOOR_MAP_IMAGE_HEIGHT_MAX,
      Math.max(FLOOR_MAP_IMAGE_HEIGHT_MIN, viewportHeight * FLOOR_MAP_IMAGE_HEIGHT_VIEWPORT_RATIO)
    )
  );

export const fitFloorMapImageWidth = (
  containerWidth: number,
  aspectRatio = 0,
  imageHeightMax = FLOOR_MAP_IMAGE_HEIGHT_MIN
): number =>
  Math.round(
    Math.min(
      FLOOR_MAP_IMAGE_WIDTH_MAX,
      Math.max(
        FLOOR_MAP_IMAGE_WIDTH_MIN,
        Math.min(containerWidth, aspectRatio > 0 ? imageHeightMax / aspectRatio : containerWidth)
      )
    )
  );
